webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(8)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(12),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_alfresco__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_alfresco___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_alfresco__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default.a, Alfresco: __WEBPACK_IMPORTED_MODULE_1__components_alfresco___default.a
  },
  data: function data() {
    return {
      messages: "",
      alfSession: { uploadUrl: "http://localhost" }
    };
  },

  methods: {
    showSuccess: function showSuccess(file) {
      console.log('A file was successfully uploaded');
    },
    sending: function sending(file, xhr, formData) {
      formData.append("title", "Test3.jpg");
      formData.append("year", "2017");
      formData.append("folder", "345ea9db-4ffa-4ced-81ed-1484c9f6ff8b");
      console.log(formData);
    },
    sessionError: function sessionError(e) {
      this.messages += e + "\n";
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cookie__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alfresco',
  components: {
    VueCookie: __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a
  },
  data: function data() {
    return {
      loggedIn: false,
      ticket: "",
      username: "",
      password: ""
    };
  },

  watch: {
    ticket: function ticket(newValue) {
      if (/TICKET_[0-9a-f]{40}/.test(newValue)) {
        this.$cookie.set('ticket', this.ticket);
        this.loggedIn = true;
        this.$emit("input", { uploadUrl: this.serverAddress + '/alfresco/service/saisie/newdoc?alf_ticket=' + this.ticket });
        this.$emit("connected");
      } else {
        this.$cookie.delete('ticket');
        this.$cookie.delete('username');
        this.$cookie.delete('password');
        this.loggedIn = false;
        this.$emit("disconnected");
      }
    }
  },
  props: {
    value: {
      uploadUrl: this.serverAddress + '/alfresco/service/saisie/newdoc'
    },
    serverAddress: {
      type: String,
      default: ""
    }
  },
  methods: {
    doLogin: function doLogin(username, password) {
      var _this = this;

      console.log("Do login!");

      axios.post(this.serverAddress + '/alfresco/service/api/login', {
        username: username,
        password: password
      }).then(function (response) {
        _this.ticket = response.data.data.ticket;
        _this.$cookie.set('username', username);
        _this.$cookie.set('password', password);
        _this.$emit('message', "Succès: doLogin()");
      }).catch(function (error) {
        _this.$emit('message', "Une erreur s'est produite lors de la tentative de connexion.");
      });
    },
    doLogout: function doLogout() {
      var _this2 = this;

      console.log("Do logout!");

      axios.delete(this.serverAddress + '/alfresco/service/api/login/ticket/' + this.ticket, {
        auth: {
          username: this.username,
          password: this.password
        }
      }).then(function (response) {
        _this2.ticket = "";
        _this2.$emit('message', "Succès: doLogout()");
      }).catch(function (error) {
        _this2.$emit('message', "Une erreur s'est produite lors de la fermeture de session.");
      });
    },
    validateTicket: function validateTicket(ticket, username, password) {
      var _this3 = this;

      console.log("Validate ticket");
      axios.get(this.serverAddress + '/alfresco/service/api/login/ticket/' + this.ticket, {
        auth: {
          username: username,
          password: password
        }
      }).then(function (response) {
        _this3.ticket = ticket;
        _this3.$cookie.set('ticket', _this3.ticket);
        _this3.loggedIn = true;
        _this3.$emit('message', "Succès: validateTicket()");
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response);
          switch (error.response.status) {
            case 401:
              _this3.$emit('message', "Accès interdit: validateTicket()");
              break;
            default:
              _this3.$emit('message', "Une erreur générale s'est produite lors de la validation du ticket...");
          }
        } else {
          _this3.$emit('message', "Une erreur générale s'est produite lors de la validation du ticket...");
        }
        _this3.ticket = "";
      });
    }
  },
  created: function created() {
    console.log("Created!");
    if (this.$cookie.get('ticket') && this.$cookie.get('username') && this.$cookie.get('password')) {
      this.validateTicket(this.$cookie.get('ticket'), this.$cookie.get('password'), this.$cookie.get('password'));
    } else {
      console.log("No cookies :(");
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(9)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(13),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f9694e02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('alfresco', {
    attrs: {
      "server-address": ""
    },
    on: {
      "message": _vm.sessionError
    },
    model: {
      value: (_vm.alfSession),
      callback: function($$v) {
        _vm.alfSession = $$v
      },
      expression: "alfSession"
    }
  }), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.messages))]), _vm._v(" "), _c('dropzone', {
    attrs: {
      "id": "myVueDropzone",
      "url": _vm.alfSession.uploadUrl
    },
    on: {
      "vdropzone-success": _vm.showSuccess,
      "vdropzone-sending": _vm.sending
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alfresco"
  }, [_c('h1', [_vm._v("Session Alfresco")]), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Session active")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doLogout
    }
  }, [_vm._v("Déconnexion")])]) : _c('div', [_c('p', [_vm._v("Session inactive")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.doLogin(_vm.username, _vm.password)
      }
    }
  }, [_vm._v("Connexion")])])])
},staticRenderFns: []}

/***/ })
],[7]);


// WEBPACK FOOTER //
// static/js/app.6e75079d99c2f1346817.js